<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Embrio">
		  <z-table title="Senarai" :headers="table.headers" :items="table.items" :meta="table.meta">
          <template #button v-if="$zutil.role('Penternak') || $zutil.role('Pentadbir Sistem')">
              <w-button dark class="green--bg ml1" :route="$route('embrio.form',0)" >
                  <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
              </w-button>
          </template>
		    <template #header-label="{ header, label, index }">
		      <template v-if="header.key == 'action'">
			      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
            TINDAKAN
          </template>
		      <template v-else>
		      	{{ label }}
		      </template>
		    </template>
		    <template #item-cell.action="{ item, label, header, index }">
		      <w-flex class="flex justify-center">
		        <inertia-link :href="$route('embrio.show',item.id)" class="w-button w-button--dark size--md info-dark1--bg"> 
              <w-icon xs class="mr2">fal fa-eye</w-icon>  PAPAR
            </inertia-link>
             &nbsp;  
            <w-button  bg-color="warning"  :route="$route('embrio.form',item.id)" class="be fs-2" v-if="item.lkp_status_id == 12 || item.lkp_status_id == 13">
              <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI 
            </w-button>
		      </w-flex>
		    </template>
		  </z-table>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'embrio',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Embrio', route: '/embrio' },
      ]
      
    }
  },
  methods: {
    
  
  },

  watch: {

  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
